import React from "react";
import ColeccionArticulos from "../../ColeccionArticulos";
import { ColeccionBody, ColeccionBox, ColeccionFooter, ColeccionHeader, } from "./ColeccionStyled";
var Coleccion = function (_a) {
    var url = _a.url, coleccion = _a.coleccion;
    return (React.createElement(ColeccionBox, null,
        React.createElement(ColeccionHeader, { style: { backgroundImage: "url(\"".concat(coleccion.mini_header, "\")") } },
            React.createElement("h2", null, coleccion.titulo)),
        React.createElement(ColeccionBody, null,
            React.createElement("p", null, coleccion.descripcion),
            React.createElement(ColeccionArticulos, { articulos: coleccion.productos })),
        React.createElement(ColeccionFooter, null,
            React.createElement("a", { href: "colecciones/" + url }, "Explorar"))));
};
export default Coleccion;
